import {
	SetRouteDeliveryScheduleMutation,
	UnsetRouteDeliveryScheduleMutation
} from "~/gql/mutations/routeDeliverySchedule.generated";
import { GetRouteDeliveryScheduleConfigQuery } from "~/gql/queries/routeDeliverySchedule.generated";

export const routeDeliveryScheduleEndpoints = {
	GetRouteDeliveryScheduleConfig: {
		providesTags: ["RouteDeliveryScheduleConfig"] as AddTagTypes,
		transformResponse: (res: GetRouteDeliveryScheduleConfigQuery) => res
	},
	SetRouteDeliverySchedule: {
		invalidatesTags: ["RouteDeliveryScheduleConfig"] as AddTagTypes,
		transformResponse: (res: SetRouteDeliveryScheduleMutation) => res
	},
	UnsetRouteDeliverySchedule: {
		invalidatesTags: ["RouteDeliveryScheduleConfig"] as AddTagTypes,
		transformResponse: (res: UnsetRouteDeliveryScheduleMutation) => res
	}
};
